import { useFxRates } from '@/lib/fxRates';

/**
 * Current rate (units of `currency` per 1 EUR) from the public `fx_rates`
 * table. Shares the same cached query as every card, so the listing page and
 * cards always show the same converted amounts. Undefined/null → hide.
 */
export function useFxRatePerEur(currency: string) {
  const q = useFxRates();
  const rate = q.data?.[currency.toUpperCase()];
  return { ...q, data: rate && rate > 0 ? rate : null };
}
